export default __webpack_public_path__ + "static/youtube-channel-1c4d491e5815854e3318242b18e32c01.svg";